import React from "react";
import { Form } from "react-bootstrap";

type ZCheckboxButtonProps = {
    type: "radio" | "checkbox";
    name?: string;
    id?: string;
    className?: string;
    label?: string;
    checked?: boolean;
    onClick?: () => void;
}

export const ZCheckboxButton = ({type, name, id, className, label, checked, onClick}: ZCheckboxButtonProps) => {
    return (
        <span
            className={`d-flex prevent-select align-items-center ${className ? className : ""}`}
            draggable={false}
            onClick={onClick}
        >
        <Form.Check
            name={name}
            type={type}
            className={`d-flex zcheckbox vertical-align-middle ${label != null ? "pe-2" : ""}`}
            id={id ?? name ?? "default-checkbox"}
            checked={checked}
            onChange={() => {}}
        />{label}</span>
    );
}